import {
    GridRenderCellParams,
} from '@mui/x-data-grid-pro'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'

import {
    ContractCurrency,
    PositionType,
} from 'app/enums/label.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    LongTermLeaseInvoicePositionType,
} from 'app/requests/LongTermLeaseInvoice/LongTermLeaseInvoice.types'
import AllPositionTypeCodes from 'app/types/positionTypeCode.enum'
import formatCurrencyValue from 'app/utils/formatCurrencyValue'

const getColumns = ({
    currency,
    disabled,
    handleDeleteRow,
}: {
    currency?: ContractCurrency,
    disabled?: boolean,
    handleDeleteRow: (id: number) => void
}): SkyDataGridColumnDefinition<LongTermLeaseInvoicePositionType & {totalPrice: string}>[] => {
    return [
        {
            name: 'positionCode',
            componentName: 'EnumValue',
            allowedValuesEnum: AllPositionTypeCodes,
            sorting: false,
            labelKey: 'POSITION',
        },
        {
            name: 'positionType',
            componentName: 'EnumValue',
            allowedValuesEnum: PositionType,
            sorting: false,
            labelKey: 'POSITION_TYPE',
        },
        {
            name: 'positionDescription',
            sorting: false,
            labelKey: 'DESCRIPTION',
        },
        {
            name: 'quantity',
            sorting: false,
            labelKey: 'QUANTITY',
        },
        {
            name: 'unitPrice',
            sorting: false,
            renderCell: (params: GridRenderCellParams<LongTermLeaseInvoicePositionType>) => {
                const {
                    unitPrice,
                } = params.row

                return (
                    <>
                        {`${formatCurrencyValue(unitPrice)} ${currency || ''}`}
                    </>
                )
            },
            labelKey: 'UNIT_PRICE',
        },
        {
            name: 'totalPrice',
            sorting: false,
            renderCell: (params: GridRenderCellParams<LongTermLeaseInvoicePositionType>) => {
                const {
                    quantity,
                    unitPrice,
                } = params.row

                return (
                    <>
                        {`${formatCurrencyValue(unitPrice * quantity)} ${currency || ''}`}
                    </>
                )
            },
            labelKey: 'TOTAL_PRICE',
        },
        {
            name: 'id',
            sorting: false,
            renderCell: (params: GridRenderCellParams<LongTermLeaseInvoicePositionType>) => {
                if (disabled) return null
                return (
                    <IconButton
                        size="small"
                        onClick={() => {
                            handleDeleteRow(params.row.id)
                        }}
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                )
            },
            labelKey: ' ',
        },
    ]
}

export default getColumns
